import {
  ChevronDown
} from "./chunk-5VDSC7QK.mjs";

// src/accordion/src/accordion.tsx
import * as RadixAccordion from "@radix-ui/react-accordion";
import { forwardRef } from "react";
import { cx } from "class-variance-authority";
import { jsx, jsxs } from "react/jsx-runtime";
var AccordionTrigger = forwardRef(
  ({ title, secondaryInfo, boldTitle, ...rest }, forwardedRef) => /* @__PURE__ */ jsxs(
    RadixAccordion.Trigger,
    {
      ...rest,
      className: cx(
        "group",
        "text-left",
        "inline-flex w-full items-center justify-between px-1 py-2",
        "text-surface-dark",
        "data-[disabled]:text-surface-strong",
        { "font-semibold": boldTitle }
      ),
      ref: forwardedRef,
      children: [
        title,
        /* @__PURE__ */ jsxs("div", { className: "flex gap-3 text-left text-surface-body group-data-[disabled]:text-surface-strong", children: [
          secondaryInfo,
          /* @__PURE__ */ jsx("div", { className: "group-radix-state-open:duration-300 ml-2 size-5 origin-center group-data-[state=open]:-scale-y-100", children: /* @__PURE__ */ jsx(ChevronDown, {}) })
        ] })
      ]
    }
  )
);
var AccordionContent = forwardRef(
  ({ children, ...rest }, forwardedRef) => /* @__PURE__ */ jsx(
    RadixAccordion.Content,
    {
      ...rest,
      className: "text-smdata-[disabled]:text-surface-strong w-full px-1 pb-4 text-surface-body",
      ref: forwardedRef,
      children
    }
  )
);
var AccordionItem = forwardRef(
  ({ children, value, removeDivider, disableHover, ...rest }, forwardedRef) => /* @__PURE__ */ jsx(
    RadixAccordion.Item,
    {
      ...rest,
      className: cx(
        "w-full",
        "rounded-t",
        { "border-surface-strong border-b": !Boolean(removeDivider) },
        { "hover:bg-surface-subtle": !Boolean(disableHover) }
      ),
      ref: forwardedRef,
      value,
      children
    }
  )
);
var Accordion = forwardRef(
  ({
    items,
    disabled = false,
    removeDivider = false,
    disableHover = false,
    boldTitle = false,
    type = "multiple",
    "data-testid": dataTestId
  }, forwardedRef) => /* @__PURE__ */ jsx(
    RadixAccordion.Root,
    {
      className: cx("w-full space-y-4", {
        "pointer-events-none text-surface-strong": disabled
      }),
      ...type === "single" && { collapsible: true },
      "data-testid": dataTestId,
      disabled,
      ref: forwardedRef,
      type,
      children: items.map(({ content, title, ...rest }) => {
        return /* @__PURE__ */ jsxs(
          AccordionItem,
          {
            disableHover,
            removeDivider,
            value: title,
            children: [
              /* @__PURE__ */ jsx(AccordionTrigger, { ...rest, boldTitle, title }),
              /* @__PURE__ */ jsx(AccordionContent, { children: content })
            ]
          },
          title
        );
      })
    }
  )
);

export {
  Accordion
};
